<template>
    <div class="appMain">
        <div class="app-main-breadcrumb" v-if="1&&breadcrumbList[breadcrumbList.length - 1].meta.title">
            <!-- <div>您当前位置 ：</div> -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item v-if="breadCrumbItem.path != ''" :to="{ path: `${breadCrumbItem.path}` }"
                                    v-for="(breadCrumbItem, index) in breadcrumbList" :key="index">
                    {{breadCrumbItem.meta.title}}<span v-if="breadCrumbItem.meta.title == '商城数据'" style="padding: 0 15px;color: orange;display: none;">(当前页数据仅针对公众号商城用户)</span>
                </el-breadcrumb-item>
            </el-breadcrumb>

        </div>
        <div class="app-main-breadcrumb-index" v-else></div>
        <div class="app-main-container">
<!--            <sunMenu v-if="!hideThirdMenu"></sunMenu>-->
            <div class="app-main-content-box">
                <transition name="fade-transform" mode="out-in">
                    <router-view class="app-main-router-view"/>
                </transition>
                <div class="app-main-footer">
					<img src="../../assets/images/footer_logo.png" />
                    <p v-if="isShow">由启博提供技术支持</p>
                </div>
            </div>

        </div>
        <audio id="music_new_message" :src="videoSrc" preload="preload" @click="playClick"></audio>
    </div>
</template>

<script>
    import sunMenu from '@/components/subMenu/subMenu'
    import videoSrc from '@/assets/voice/new_message2.ogg'
    export default {
        name: 'appMain',
        data() {
            return {
                autoplay:null,
				isShow: 1 // 是否显示启博技术支持
            }
        },
        components: {
            sunMenu
        },
        computed: {
            breadcrumbList() {
                return this.$route.matched
            },
            hideThirdMenu() {
                return this.$route.meta.hideThirdMenu
            },
            videoSrc(){
                return this.$store.state.user.chosenVoice.url || videoSrc
            }
        },
        methods: {
            /**
             * 消息推送音频
             */
            playClick() {
                this.autoplay = document.getElementById('music_new_message')
                this.autoplay.play()
            },
			getSellerInfoStatus() {
			  this.$http.sellerInfoStatusAPI().then(res => {
				  console.log(res,'status')
				  if (res.status == 1) {
					  this.isShow = res.data.is_show
				  }
			  })
			}
        },
		created() {
            // console.log(this.$route,'route')
            // console.log(this.breadcrumbList,this.breadcrumbList[this.breadcrumbList.length - 1].meta.title,1111333)
			// 是否显示启博支持
			this.getSellerInfoStatus()
		},
        mounted() {
            setTimeout(() => {
                if(document.querySelector('.tool-btn')){
                    document.querySelector('.tool-btn').style.display = 'block'
                    document.querySelector('.tool-box').style.display = 'block'
                }
            },1000)
            eventBus.$on('receivedMsg', (val) => {
                this.playClick()
            })

        },
        beforeDestroy() {
            if(document.querySelector('.tool-btn')){
                document.querySelector('.tool-btn').style.display = 'none'
                document.querySelector('.tool-box').style.display = 'none'
            }

        },
    }
</script>

<style lang="scss">
    .appMain {
        display: flex;
        flex-direction: column;
        position: relative;
        height: 100%;
        width: 100%;

        ul {
            margin: 0;
        }
        .app-main-breadcrumb-index{
            height: 16px;
        }
        .app-main-breadcrumb {
            height: 46px;
            line-height: 46px;
            // background-color: #fff;
            font-size: 12px;
            color: #333333;
            padding: 0 25px 0 17px;
            display: flex;
            align-items: center;
            z-index: 9;
            // box-shadow: 0 3px 10px #ddd;
            .el-breadcrumb__item {
                display: inline-block;
                padding-left: 5px;
            }
			.el-breadcrumb__item:nth-child(1){
				border-left: 3px solid #333;
			}
            .el-breadcrumb {
                font-size: 12px;

                .el-breadcrumb__inner {
                    color: #333;
                    font-weight: normal;

                    &:hover {
                        color: #428efe;
                    }
                }

                .el-breadcrumb__separator {
                    color: #428efe;
                }
            }
        }

        .app-main-container {
            flex: 1;
            display: flex;
            height: calc(100% - 50px);
        }

        .app-main-content-box {
            flex: 1;
            overflow-x: hidden;
            overflow-y: scroll;
            height: 100%;
            display: flex;
            flex-direction: column;
            /*position: relative;*/

            .app-main-router-view {
                flex: 1;
                padding: $mainContentPadding;
                padding-top: 0;
            }
        }

        .app-main-footer {
            // height: 50px;
            // line-height: 50px;
            // color: #c4c4c4;
			display: flex;
			flex-direction: column;
			align-items: center;
			padding-top: 72px;
			padding-bottom: 56px;
			img{
				display: block;
				width: 120px;
				height: 30px;
				margin-bottom: 5px;
			}
			p{
				color: #4e4f51;
				font-style: italic;
				font-size: 12px;
				text-align: center;
				letter-spacing: 3px;
			}
        }

    }
</style>
